import BenchlingConfig from 'BenchlingConfig';
import {ActionOrigin} from 'constants/AnalyticsConstants';
import APIUtil from 'util/APIUtil';

export interface CollaborationAnalyticsMetadata {
  actionOrigin?: ActionOrigin;
  itemId: string;
}

export function getCollaborationAnalyticsMetadata(
  apiIdentifier: string
): CollaborationAnalyticsMetadata | undefined {
  if (
    !(
      APIUtil.isEntry(apiIdentifier) ||
      APIUtil.isDocument(apiIdentifier) ||
      (BenchlingConfig.ELN_REALTIME_TEMPLATE_UPDATES &&
        (APIUtil.isEntryTemplate(apiIdentifier) || APIUtil.isSubtemplate(apiIdentifier)))
    )
  ) {
    return;
  }

  return {actionOrigin: ActionOrigin.NOTEBOOK, itemId: apiIdentifier};
}
